<template>
  <div class="container">
    <div class="w">
      <div class="content">
        <div class="left" @click="goHome">
          <img class="logo" src="../assets/img/logo1.png" alt="" />
        </div>
        <div
          class="right"
          @mouseover="immigration"
          @mouseout="shiftOut"
          @click="clickRight"
        >
          <div class="top" v-if="userInfo">
            <img
              class="avatar"
              :src="userInfo.avatar"
              alt=""
              v-if="userInfo.avatar != ''"
            />
            <img class="avatar" src="../assets/img/形状 16.png" alt="" v-else />
            <span class="name">{{ userInfo.real_name }}</span>
          </div>
          <div class="login-register" v-else>
            <div class="login" style="margin-right: 5px" @click="goLogin">
              登录 / 注册
            </div>
          </div>
          <!-- 气泡框 v-show="isBubbleBox -->
          <div class="bubbleBox" v-show="isBubbleBox">
            <div class="bubbleBox-top">
              <div class="bubbleBox-top-top">
                <div class="bubbleBox-top-top-left">
                  {{ userInfo.real_name }}
                </div>
                <div class="bubbleBox-top-top-right">
                  {{ userInfo.identity }}
                </div>
              </div>
              <div class="bubbleBox-top-bottom">{{ userInfo.mobile }}</div>
            </div>
            <div class="bubbleBox-list" @click="goMy(0)">
              <img src="@/assets/img/矩形_619_拷贝_3.png" alt="" />
              <span>我的问题反馈</span>
            </div>
            <div class="bubbleBox-list" @click="goMy(1)">
              <img src="@/assets/img/椭圆_2.png" alt="" />
              <span>个人信息</span>
            </div>
            <div class="bubbleBox-list" @click="goMy(2)">
              <img src="@/assets/img/矩形_619.png" alt="" />
              <span>修改密码</span>
            </div>
            <div class="bf"></div>
            <div class="bubbleBox-list" @click="LogOutOfLogin">
              <img src="@/assets/img/形状_103.png" alt="" />
              <span>退出登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
   
<script>
import { $get_user_info, $login_out } from "@/api";
import { message } from "ant-design-vue";
import { mapState } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      showPopover: false,
      isBubbleBox: false, // 控制 气泡框的 显示/隐藏
      time: null,
      userInfo: "", // 个人信息
      isToken: localStorage.getItem("token"),
    };
  },
  computed: {
    ...mapState("permissions", ["isUpdate"]),
  },
  watch: {
    isUpdate() {
      if (this.isUpdate) {
        this.getDate();
        setTimeout(() => {
          this.$store.dispatch("permissions/isUpdate", false);
        }, 1000);
      }
    },
  },
  mounted() {
    this.getDate();
  },
  methods: {
    // 获取数据
    async getDate() {
      try {
        let res = await $get_user_info();
        this.userInfo = res.data;
      } catch (error) {}
    },
    // 点击logo
    goHome() {
      this.$router.push({ name: "Home" });
    },
    // 点击头像
    clickRight() {
      if (localStorage.getItem("token")) {
        return;
      } else {
        this.$router.push({ name: "Login" });
      }
    },
    // 鼠标移入 头像
    immigration() {
      if (localStorage.getItem("token")) {
        this.isBubbleBox = true;
      }
    },
    // 鼠标移出 头像
    shiftOut() {
      this.isBubbleBox = false;
    },
    // 跳转去 我的 组件
    goMy(index) {
      let name = {
        0: "feedback",
        1: "information",
        2: "change",
      };
      this.$router.push({ name: name[index], query: { index } });
    },
    // 退出登录
    async LogOutOfLogin() {
      try {
        let res = await $login_out();
        message.success("退出登录成功");
        localStorage.removeItem("token");
        setTimeout(() => {
          this.$router.push({ name: "Login" });
        }, 1500);
      } catch (error) {}
    },
    // 登录
    goLogin() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
   
<style lang="less" scoped>
.container {
  background-color: #fff;
}

.w {
  width: 1280px;
  margin: 0 auto;
}

.content {
  height: 80px;
  display: flex;
  justify-content: space-between;

  .top {
    display: flex;
    align-items: center;
  }

  .left {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .right {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    .login-register {
      display: flex;
      align-items: center;
      .login {
        background: #ea4949;
        height: 30px;
        font-size: 16px;
        padding: 5px;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
    }
  }

  .logo {
    width: 162px;
    height: 22px;
  }

  .avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }

  .name {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    // line-height: 20px;
    margin-left: 15px;
    cursor: pointer;
  }
}

.bubbleBox {
  z-index: 99;
  position: absolute;
  top: 80px;
  right: -40%;
  width: 179px;
  background: #ffffff;
  box-shadow: 0px 11px 12px 0px rgba(60, 60, 60, 0.18);

  .bubbleBox-top {
    width: 170px;
    background: #333333;
    margin: 0 auto;
    padding: 15px 17px;

    .bubbleBox-top-top {
      margin-bottom: 9px;
      display: flex;
      align-items: center;

      .bubbleBox-top-top-left {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #ffffff;
        margin-right: 6px;
      }

      .bubbleBox-top-top-right {
        width: 58px;
        height: 20px;
        background-image: url("~@/assets/img/2.png");
        text-align: center;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .bubbleBox-top-bottom {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }

  .bubbleBox-list {
    padding: 13px 25px;
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      width: 17px;
      height: 17px;
      margin-right: 9px;
    }

    span {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }

  .bubbleBox-list:hover {
    background: #e9e9e9;
  }

  .bf {
    width: 179px;
    height: 1px;
    background: #dadada;
  }
}

// H5样式
@media screen and (max-width: 767px) {
  .container {
    display: none;
  }
}
</style>
